import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import ProductList from './components/ProductList';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import AdminProducts from './components/AdminProducts';
// CartProvider is applied in index.js; no need to wrap again here

/**
 * Main application component. Defines the top‑level layout and routing.
 * Displays a header on every page and renders the appropriate
 * component based on the current route.
 */
function App() {
  const location = useLocation();

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    in: {
      opacity: 1,
      y: 0,
    },
    out: {
      opacity: 0,
      y: -20,
    },
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.5,
  };

  return (
    <div>
      <Header />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
          transition={pageTransition}
        >
          <Routes location={location}>
            <Route path="/" element={<ProductList />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin" element={<AdminProducts />} />
            <Route path="*" element={<main className="not-found"><div><span>404</span><h1>Fant ikke siden</h1><p>Adressen finnes ikke. Gå tilbake til butikken for å utforske produktene.</p><Link className="bag-primary" to="/">Til butikken →</Link></div></main>} />
          </Routes>
        </motion.div>
      </AnimatePresence>
      
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '12px',
            boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
            color: '#2d3748',
            fontWeight: '500',
          },
          success: {
            iconTheme: {
              primary: '#48bb78',
              secondary: '#ffffff',
            },
          },
          error: {
            iconTheme: {
              primary: '#f56565',
              secondary: '#ffffff',
            },
          },
          loading: {
            iconTheme: {
              primary: '#667eea',
              secondary: '#ffffff',
            },
          },
        }}
      />
    </div>
  );
}

export default App;